var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8105 10.3145L6.86426 20.2607C6.83702 20.288 6.80929 20.3104 6.78125 20.3291L6.69531 20.375C6.6284 20.4016 6.56203 20.414 6.49316 20.4141H3.66797C3.51104 20.4141 3.40335 20.3664 3.31055 20.2734L3.30859 20.2715C3.21563 20.1787 3.16797 20.071 3.16797 19.9141V17.0889C3.16799 17.02 3.18073 16.9544 3.20703 16.8887V16.8877C3.23065 16.8285 3.26704 16.7721 3.32129 16.7178L13.2676 6.77148L16.8105 10.3145ZM17.5312 3.16406C17.9609 3.16412 18.3034 3.3063 18.5898 3.59277L19.9893 4.99219C20.2825 5.28539 20.4305 5.62738 20.4434 6.04199C20.4558 6.44529 20.325 6.77465 20.0391 7.06055L18.9648 8.13379L15.4268 4.63574L16.4717 3.59277C16.7581 3.30636 17.1007 3.16406 17.5312 3.16406Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMenuIcon);
export default __webpack_public_path__ + "static/media/Edit-Menu-Icon.bfa62136a12f1276a61ee5a18aae6893.svg";
export { ForwardRef as ReactComponent };